import { HttpClient, HttpContext, HttpUrlEncodingCodec } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CategoryTag, OccCategoryTagsListResponse } from '@catalog/const';
import { HTTP_CONTEXT_ENDPOINT, OCC_ENDPOINTS } from '@core/const';
import { OccEndpointsService } from '@spartacus/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class OccCategoryTagsService {
  private queryCodec = new HttpUrlEncodingCodec();

  constructor(
    private http: HttpClient,
    private occEndpoints: OccEndpointsService,
  ) {}

  loadTagsList(categoryCode: string): Observable<OccCategoryTagsListResponse> {
    const url = this.occEndpoints.buildUrl(OCC_ENDPOINTS.tags, { queryParams: { categoryCode, fields: 'DEFAULT' } });

    return this.http
      .get<OccCategoryTagsListResponse>(url, {
        context: new HttpContext().set(HTTP_CONTEXT_ENDPOINT, OCC_ENDPOINTS.tags),
      })
      .pipe(
        map(({ tags }: OccCategoryTagsListResponse) => ({
          tags: tags.map((tag: CategoryTag) => this.decodeTagFacetFilter(tag)),
        })),
      );
  }

  loadTagItem(slug: string): Observable<CategoryTag> {
    const url = this.occEndpoints.buildUrl(OCC_ENDPOINTS.tag, {
      urlParams: { slug, fields: 'DEFAULT' },
      queryParams: { slug },
    });

    return this.http
      .get<CategoryTag>(url, {
        context: new HttpContext().set(HTTP_CONTEXT_ENDPOINT, OCC_ENDPOINTS.tag),
      })
      .pipe(map((tag: CategoryTag) => this.decodeTagFacetFilter(tag)));
  }

  private decodeTagFacetFilter(tag: CategoryTag): CategoryTag {
    return {
      ...tag,
      facetFilter: tag.facetFilter && this.queryCodec.decodeValue(tag.facetFilter),
    };
  }
}
